module.exports = __webpack_public_path__ + "static/media/mov.e15ef341.svg";